module.exports = __webpack_public_path__ + "media/4-8.8ac11c2c.mp4";